import $ from 'jquery';
// import '../../../../../bower_components/bootstrap-tabcollapse/bootstrap-tabcollapse';
import 'bootstrap-tabcollapse';

$(document).ready(function () {
    $('.tabCollapse').tabCollapse({
        tabsClass: 'hidden-xs hidden-sm',
        accordionClass: 'visible-sm visible-xs accordiontoHide'
    });

    setTimeout(function () {
        collapseAccordion();
    }, 100);
})


function collapseAccordion() {
    $('.accordiontoHide .panel-collapse').removeClass('in');
    $('.accordiontoHide .panel-heading a').addClass('collapsed');
}


$('.accordiontoHide').on('shown.bs.collapse', function (e) {
    $('html,body').animate({
        scrollTop: ($(e.target).offset().top) - 175
    }, 500);
});
